
import React from 'react';
import { Label } from '@/components/ui/label';
import { Checkbox } from '@/components/ui/checkbox';

interface ProductsCheckListProps {
  selectedProducts: string[];
  onProductToggle: (product: string) => void;
}

const FINANCIAL_PRODUCTS = [
  { id: 'fixed-deposits', label: 'Fixed Deposits' },
  { id: 'mutual-funds', label: 'Mutual Funds' },
  { id: 'stocks', label: 'Stocks' },
  { id: 'insurance', label: 'Insurance' },
  { id: 'real-estate', label: 'Real Estate' },
  { id: 'gold', label: 'Gold' },
  { id: 'ppf-epf', label: 'PPF/EPF' },
  { id: 'others', label: 'Others' },
];

const ProductsCheckList: React.FC<ProductsCheckListProps> = ({
  selectedProducts,
  onProductToggle,
}) => {
  return (
    <div>
      <Label className="mb-3 block">Existing Financial Products</Label>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {FINANCIAL_PRODUCTS.map((product) => (
          <div key={product.id} className="flex items-center space-x-2">
            <Checkbox 
              id={product.id} 
              checked={selectedProducts.includes(product.id)} 
              onCheckedChange={() => onProductToggle(product.id)}
            />
            <label
              htmlFor={product.id}
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              {product.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductsCheckList;
